import * as variables from './variables.js';

import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import './lib/AnimationEasing';

import "./component/Analytics";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu .menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 600, 'easeOutCirc')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import Forms from './component/Forms';
Forms.init();


/* Basic Carousels */
import Carousel from './component/Carousel';
const featureCarousel = document.querySelector('body.__entry .carousel');
if (featureCarousel) {
	new Carousel({
		analyticsCategory: 'Feature Carousel',
		carouselEl: featureCarousel as HTMLElement,
		duration: 8000,
		allowIndicatorClick: false,
		autoAdvance: true,
		autoHeight: true,
		progressEl: document.getElementById('featureCarousel-indicator')
	});
}
const carouselElem = document.querySelector('body:not(.__entry) .carousel');
if (carouselElem) {
	new Carousel({
		analyticsCategory: 'Carousel',
		carouselEl: carouselElem as HTMLElement,
		duration: 7500,
		allowIndicatorClick: true,
		autoHeight: true,
		// autoAdvance: true
	});
}


/* Silky smooth scrolling */
import SmoothScroll from './lib/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
mySmoothScroll.add('#sections > a', {
	duration: 1200,
	easing: 'easeOutCirc'
});


/* Parallax background */
import ParallaxGraphic from './lib/ParallaxGraphic';
const parallaxGraphic = new ParallaxGraphic();


/* Collapable Groups */
import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup({
	container: '.personnelGroup',
	item: '.personnel',
	trigger: '.personnel__heading',
	target: '.personnel__items',
	defaultIndex: 0
});


/* Fixes for 100vh items that extend below scroll on mobile */
var fixMobileHeight = function(){
	[
		document.querySelector('body.__entry .carousel'),
		document.querySelector('main[data-tablet-intro="true"] .pageIntro')
	].forEach(element => {
		if (element){
			let overage = element.getBoundingClientRect().bottom - window.innerHeight;
			if (overage > -1){
				element.setAttribute('style','height: calc(100vh - '+ overage +'px)');
			}
		}
	});
};
fixMobileHeight();

import init from './component/LightboxForm';
init();
